import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import type { ProfileAddressWithTypeId } from "web_myplann/Profile/Types/ProfileAddressWithTypeId";
import { formatProfileAddress } from "web_myplann/Profile/Utils/formatProfileAddress";
import { formatProfileFullName } from "web_myplann/Profile/Utils/formatProfileFullName";
import { formatProfileName } from "web_myplann/Profile/Utils/formatProfileName";
import { getProfileAddresses } from "web_myplann/Profile/Utils/getProfileAddresses";

export const useProfileOverview = () => {
	const { data: userData, isLoading } = useClientQuery();

	const data = userData?.data;
	const clientNotFound = !isLoading && !data;

	const addresses = userData?.addresses as
		| ProfileAddressWithTypeId[]
		| undefined;
	const { permanentAddress: permanentAddressDto, contactAddresses } =
		getProfileAddresses(addresses);

	return {
		isLoading,
		clientNotFound,
		name: formatProfileFullName(data),
		displayName: formatProfileName(data),
		photo: userData?.photo ?? undefined,
		email: userData?.contactEmail ?? "",
		phone: userData?.contactPhone ?? "",
		permanentAddress: formatProfileAddress(permanentAddressDto),
		contactAddress: formatProfileAddress(contactAddresses?.[0]),
	};
};
